import type { IRootState } from "./app/store";

type IRtkQuerySubstate = {
  status?: string;
  isFetching?: boolean;
};

export const selectIsAnyRtkQueryRequestPending = (state: IRootState): boolean => {
  const api = state.api as unknown as {
    queries?: Record<string, IRtkQuerySubstate | undefined>;
    mutations?: Record<string, IRtkQuerySubstate | undefined>;
  };

  const queriesBusy = Object.values(api.queries ?? {}).some(
    (query) => query?.status === "pending" || query?.isFetching === true
  );
  const mutationsBusy = Object.values(api.mutations ?? {}).some(
    (mutation) => mutation?.status === "pending"
  );

  return queriesBusy || mutationsBusy;
};
